/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} MonthInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} month" |
* | "other" | "{count} months" |
*
* @param {MonthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const month = /** @type {((inputs: MonthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MonthInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} month`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} months`);
		return /** @type {LocalizedString} */ ("month");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} mois`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} mois`);
		return /** @type {LocalizedString} */ ("month");
	}
});